import React from 'react';
import {SVG__Ruble} from "../../SVG/SVG";

class WishListItem extends React.Component {
    render() {
        const {item} = this.props;

        const price = (item.price > 0)? <span>{item.price} <SVG__Ruble/></span>: 'Цена по запросу';

        return (
            <div className="render-wish-list__item">
                <div className="image">
                    <img src={item.image} alt={item.name}/>
                </div>
                <div className="title"><a href={item.link}>{item.name}</a></div>
                <div className="price">{price}</div>
                <div className="action" onClick={()=>this.props._onMoveToBasket(item.id)}>
                    <div className="btn btn-primary">Добавить в корзину</div>
                </div>
                <div className="remove" onClick={() => this.props._onRemoveItem(item.id)}>
                    <svg className="svg-inline--fa fa-times fa-w-11" aria-hidden="true" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 352 512" data-fa-i2svg="">
                        <path fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                    </svg>
                </div>
            </div>
        );
    }
}

export default WishListItem;